import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';
import { MdOutlineEmail } from 'react-icons/md';
import { RiMessengerLine } from 'react-icons/ri';
import { BsWhatsapp } from 'react-icons/bs';

const Contact = () => {
	const form = useRef();
	const [done,setDone] = useState(false)

	const sendEmail = (e) => {
		e.preventDefault();
		emailjs.sendForm(
			// 'service_c4qhhn8',
			// 'template_oe13wt5',
			// form.current,
			// 'b8TCfT2FU9ipqwitU'
			'service_j068smv',
			'template_g0h4zb8',
			form.current,
			'X77TBBSCeRcqvUv6K'
		).then((result) => {
			console.log(result.text);
			setDone(true)
		}, (error) => {
			console.log(error.text);
		});
		e.target.reset();
	};

	return (
		<section id='contact'>
			<h5>Get in Touch</h5>
			<h2>Contact Me</h2>
			<div className='container contact__container'>
				<div className='contact__options'>
					{/* END OF CONTACT OPTIONS */}
					<article className='contact__option'>
						<MdOutlineEmail className='contact__option-icon' />
						<h4>Email</h4>
						<h5>mahmouddev25@gmail.com</h5>
						<a
							href='mailto:mahmoudsabry.udacity@gmail.com'
							target='_blank'
							rel='noopener noreferrer'
						>
							Send a message
						</a>
					</article>
					<article className='contact__option'>
						<RiMessengerLine className='contact__option-icon' />
						<h4>Messenger</h4>
						<h5>Mahmoud</h5>
						<a
							// href='https://m.me/catevika'
							target='_blank'
							rel='noopener noreferrer'
						>
							Send a message
						</a>
					</article>
					<article className='contact__option'>
						<BsWhatsapp className='contact__option-icon' />
						<h4>Whatsapp</h4>
						<h5>01282900378</h5>
						<a
							href='https://api.whatsapp.com/send?phone=01282900378'
							target='_blank'
							rel='noopener noreferrer'
						>
							Send a message
						</a>
					</article>
				</div>
				<form ref={form} onSubmit={sendEmail}>
					<input
						type='text'
						name='user_name'
						placeholder='Your Full Name'
						required
					/>
					<input
						type='text'
						name='subject'
						placeholder='The subject of your email'
					/>
					<input type='email' name='email' placeholder='Your Email' required />
					<textarea
						name='message'
						rows='3'
						placeholder='Your message'
						required
					></textarea>
					<button type='submit' className='btn btn-primary'>
						Send Message
					</button>
					{done && 
					<span style={{backgroundColor:"var(--color-primary)",borderRadius:"20px",textAlign:"center"}}>Tanks For Contacting , The Message Sent Succefully. We will respond as soon as possible .</span>
					}
				</form>
			</div>
		</section>
	);
};

export default Contact;
